import { z } from 'zod';
import type {
  DiscardInboundReceiptDraftRequest,
  DiscardInboundReceiptDraftResponse,
} from './discard-inbound-receipt-draft.dto.js';

export const DiscardInboundReceiptDraftRequestSchema: z.ZodType<DiscardInboundReceiptDraftRequest> =
  z
    .object({
      companyId: z.uuid(),
      draftId: z.uuid(),
    })
    .strict();

export const DiscardInboundReceiptDraftResponseSchema: z.ZodType<DiscardInboundReceiptDraftResponse> =
  z
    .object({
      discarded: z.literal(true),
    })
    .strict();
